import React from 'react';

import { ICalendarSource } from '../../../data/entities/calendar-source';
import { Paragraph } from '../paragraph/Paragraph';

interface ICalendarSourceSyncStatusProps {
	calendarSource: ICalendarSource;
}

export const CalendarSourceSyncStatus: React.FC<ICalendarSourceSyncStatusProps> = ({ calendarSource }) => {
	const attempted = !!calendarSource.last_attempted_scrape || !!calendarSource.last_successful_scrape;
	const successfullySynced = !!calendarSource.last_successful_scrape;
	const status = attempted ? (successfullySynced ? 'success' : 'error') : 'pending';
	const lastScrape = calendarSource.last_attempted_scrape ? new Date(calendarSource.last_attempted_scrape).toLocaleString() : '';
	return <div className="calendar-source-status__container">
		<div className="calendar-source-status__icon">
			<img src={`/71eb904/assets/icons/messages/${status}.svg`}></img>
		</div>
		<div className={`calendar-source-status__description calendar-source-status__description-${status}`}>
			<Paragraph>
				{status === 'success' && `Last synced ${lastScrape}`}
				{status === 'pending' && 'Awaiting first sync attempt'}
				{status === 'error' && 'Failing to sync from source'}
			</Paragraph>
		</div>
	</div>;
};
